module.exports = __webpack_public_path__ + "static/media/about.a4939115.svg";